import { useContext } from 'react';

import styled from 'styled-components';

import { SelectSkeletonContext, SelectSkeletonInputComponentProps } from '../SelectSkeleton';

import { Box, TextFieldInput } from '@aircall/tractor';

/* istanbul ignore next */
export const Input = styled(TextFieldInput)<{ backgroundColor?: string }>`
  border: none;
  background-color: ${({ backgroundColor }) => backgroundColor};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export function SelectInput({
  name,
  valueRenderer,
  backgroundColor,
  icon,
  disabled,
  placeholder,
  isOpen,
  selectedOption,
  size,
  'data-test': dataTest,
  onBlur,
}: SelectSkeletonInputComponentProps) {
  const { toggleMenu } = useContext(SelectSkeletonContext);
  return (
    <Box onClick={toggleMenu} data-test={`${dataTest}-input-container`}>
      <Input
        onBlur={onBlur}
        size={size}
        backgroundColor={backgroundColor}
        readOnly
        name={name}
        value={(valueRenderer && valueRenderer(selectedOption)) || selectedOption.label}
        placeholder={placeholder}
        icon={icon}
        open={isOpen}
        disabled={disabled}
        type='select'
        data-test={`${dataTest}-field-input`}
      />
    </Box>
  );
}
